import { Link } from "react-router-dom";
import type { ContentTopic } from "@/types/content";
import { formatCount } from "./TopicCard";

interface TopicRankItemProps {
  topic: ContentTopic;
  rank: number;
}

export default function TopicRankItem({ topic, rank }: TopicRankItemProps) {
  const isTopThree = rank <= 3;
  const rankStyle = [
    "bg-primary-500 text-background-50",
    "bg-primary-300 text-primary-950",
    "bg-secondary-400 text-secondary-950",
  ][rank - 1];

  return (
    <article className="reveal group flex items-center gap-4 py-4 border-b border-background-200/80 last:border-b-0">
      <span
        className={`shrink-0 w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold ${
          isTopThree ? rankStyle : "bg-background-100 text-foreground-500"
        }`}
        aria-hidden="true"
      >
        {rank}
      </span>

      <div className="flex-1 min-w-0">
        <h3 className="text-sm md:text-base font-medium text-foreground-950 leading-snug">
          <Link to={`/topic/${topic.id}`} className="hover:text-primary-700 transition-colors">
            {topic.title}
          </Link>
        </h3>
        <div className="mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
          <span className="px-2 py-0.5 rounded-full bg-background-100 text-foreground-600 whitespace-nowrap">
            {topic.category}
          </span>
          <span className="inline-flex items-center gap-1 whitespace-nowrap">
            <i className="ri-fire-line text-primary-500 w-3.5 h-3.5 flex items-center justify-center" />
            {formatCount(topic.heat)}
          </span>
          <span className="inline-flex items-center gap-1 whitespace-nowrap">
            <i className="ri-chat-3-line w-3.5 h-3.5 flex items-center justify-center" />
            {formatCount(topic.comments)}
          </span>
        </div>
      </div>

      <Link
        to={`/topic/${topic.id}`}
        aria-label={`查看话题：${topic.title}`}
        className="shrink-0 w-9 h-9 flex items-center justify-center rounded-full border border-background-300 text-foreground-500 group-hover:border-primary-400 group-hover:text-primary-700 transition-colors"
      >
        <i className="ri-arrow-right-line" />
      </Link>
    </article>
  );
}